import packageJson from "../../package.json";

import { routeLogin } from "routes/pages";

import type { ItfPlatformEnv, TypeEnvMode } from "types/commons";
import type { ItfHooksStateByApiHeru } from "types/commons";

export const WEB_VERSION_NUMBER: string = packageJson.version;
export const WEB_VERSION_DATE: string = packageJson.date;

const CURRENT_ENV = process.env.REACT_APP_WEB_ENV;

export const PLATFORM_ENVS: Record<TypeEnvMode, ItfPlatformEnv> = {
  production: {
    envKey: "production",
    name: { en: "Production", es: "Producción" },
  },
  staging: {
    envKey: "staging",
    name: { en: "Staging", es: "Pruebas" },
  },
  development: {
    envKey: "development",
    name: { en: "Development", es: "Desarrollo" },
  },
};

export const RUNNING_ENV_IS: ItfPlatformEnv = (function () {
  const envIs: ItfPlatformEnv = PLATFORM_ENVS[CURRENT_ENV];
  if (!envIs) throw new Error("The environment variable to find out 'which environment is running' is wrong.");
  return envIs;
})();

export const singleLayoutByRoutes = [routeLogin()];

export const INIT_STATE_REQUEST: ItfHooksStateByApiHeru<null> = {
  fail: false,
  loading: false,
  success: false,
  error: null,
  data: null,
};

export const INIT_STATE_REQUEST_DATA_AS_ARRAY: ItfHooksStateByApiHeru<any[]> = {
  ...INIT_STATE_REQUEST,
  data: [],
};

export const INIT_STATE_REQUEST_DATA_AS_OBJECT: ItfHooksStateByApiHeru = {
  ...INIT_STATE_REQUEST,
  data: {},
};

export const INIT_PAGINATION = {
  limit: 10,
  size: 0,
  start: 0,
  links: {
    next: "",
    prev: "",
  },
};

export const INIT_STATE_REQUEST_DATA_AS_ARRAY_PAGINATION: ItfHooksStateByApiHeru<any[]> = {
  ...INIT_STATE_REQUEST_DATA_AS_ARRAY,
  pagination: INIT_PAGINATION,
};

export const CLASS_ACTIVE_FILTER = "ant-table-filter-trigger active";
